import { ChangeDetectionStrategy, Component, effect, inject, input, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { ReservationApiService } from '../reservation.api.service';
import { ReservationSms, ReservationSmsWithPhone } from '../reservation.model';
import { DatePipe } from '@angular/common';
import { finalize } from 'rxjs';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
	selector: 'app-reservation-sms-list',
	standalone: true,
	imports: [MatCardModule, MatTableModule, DatePipe, MatProgressBarModule],
	templateUrl: './reservation-sms-list.component.html',
	styleUrl: './reservation-sms-list.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReservationSmsListComponent {
	readonly reservationId = input.required<string>();

	readonly reservationSmsList = signal<ReservationSmsWithPhone[]>([]);
	readonly loader = signal(false);

	readonly displayedColumns = ['createdAt', 'userName', 'phone', 'message'];

	constructor() {
		const effectRef = effect(
			() => {
				if (!this.reservationId()) {
					return;
				}
				this.loader.set(true);
				this.apiService
					.getReservationSms(Number(this.reservationId()))
					.pipe(finalize(() => this.loader.set(false)))
					.subscribe((results) => {
						this.reservationSmsList.set(this.mapSmsReservationListToFormatWithPhone(results));
						effectRef.destroy();
					});
			},
			{ manualCleanup: true, allowSignalWrites: true },
		);
	}

	private readonly apiService = inject(ReservationApiService);

	private mapSmsReservationListToFormatWithPhone(data: ReservationSms[]): ReservationSmsWithPhone[] {
		return data.map((sms) => {
			const { id, message, createdAt, recipient } = sms;

			const { firstName, lastName, userContacts } = recipient;

			const phone = userContacts.find((contact) => Boolean(contact.phone))?.phone ?? '';

			return {
				id,
				message,
				createdAt,
				recipient: {
					firstName,
					lastName,
					phone,
				},
			};
		});
	}
}
